import { createContext, createElement, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const KEY = "tij_rfq_v1";
const Ctx = createContext(null);

const load = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
};
const guessSys = () => {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    return tz.startsWith("America/") || navigator.language === "en-US" ? "imperial" : "metric";
  } catch { return "metric"; }
};

export function AppProvider({ children }) {
  const [items, setItems] = useState(load);
  const [open, setOpen] = useState(false);
  const [sys, setSys] = useState(() => { try { return localStorage.getItem("tij_units") || guessSys(); } catch { return "metric"; } });

  useEffect(() => { try { localStorage.setItem(KEY, JSON.stringify(items)); } catch { /* storage unavailable */ } }, [items]);
  useEffect(() => { try { localStorage.setItem("tij_units", sys); } catch { /* storage unavailable */ } }, [sys]);

  const add = (p, variant = "", finish = "") => {
    setItems((cur) => (cur.some((i) => i.slug === p.slug && i.variant === variant) ? cur : [...cur, { slug: p.slug, name: p.name, category: p.category, image: p.images?.[0], variant, finish }]));
    toast.success(`${p.name} added to your enquiry list`);
  };
  const remove = (idx) => setItems((cur) => cur.filter((_, i) => i !== idx));
  const clear = () => setItems([]);
  return createElement(Ctx.Provider, { value: { items, add, remove, clear, open, setOpen, sys, setSys } }, children);
}

export const useApp = () => useContext(Ctx);
